import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  loading: {
    id: 'learner.discoverPathway.loading',
    defaultMessage: 'Loading learning path',
    description: 'Spinner label',
  },
  loadError: {
    id: 'learner.discoverPathway.loadError',
    defaultMessage: 'We could not load this learning path.',
    description: 'Error state',
  },
  goBack: {
    id: 'learner.discoverPathway.goBack',
    defaultMessage: 'Back',
    description: 'Back button',
  },
  componentCount: {
    id: 'learner.discoverPathway.componentCount',
    defaultMessage: '{count, plural, one {# component} other {# components}}',
    description: 'Number of components in the path',
  },
  curriculumTitle: {
    id: 'learner.discoverPathway.curriculumTitle',
    defaultMessage: 'What you will learn',
    description: 'Heading above the list of pathway components',
  },
  optional: {
    id: 'learner.discoverPathway.optional',
    defaultMessage: 'Optional',
    description: 'Badge shown on non-mandatory pathway components',
  },
  sequentialNote: {
    id: 'learner.discoverPathway.sequentialNote',
    defaultMessage: 'Courses unlock in order as you complete each required step.',
    description: 'Note shown for sequential paths',
  },
  enroll: {
    id: 'learner.discoverPathway.enroll',
    defaultMessage: 'Enroll',
    description: 'Enroll button',
  },
  enrolling: {
    id: 'learner.discoverPathway.enrolling',
    defaultMessage: 'Enrolling',
    description: 'Enrolling state',
  },
  continue: {
    id: 'learner.discoverPathway.continue',
    defaultMessage: 'Go to learning path',
    description: 'Continue button when already enrolled',
  },
  enrollError: {
    id: 'learner.discoverPathway.enrollError',
    defaultMessage: 'Could not enroll. Try again shortly.',
    description: 'Enroll error',
  },
});

export default messages;
